import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-carta-orientacao-beneficiario',
  templateUrl: './carta-orientacao-beneficiario.component.html',
  styleUrls: ['./carta-orientacao-beneficiario.component.scss']
})
export class CartaOrientacaoBeneficiarioComponent {
  @Input() nomeTitular: string = '';
  @Input() dataAssinaturaCartaOrientacaoDS: string = '';
  @Input() horaAssinaturaCartaOrientacaoDS: string = '';
  @Input() nomeCorretora: string = '';
  @Input() nomeVendedor: string = '';
}
